// extracted by mini-css-extract-plugin
module.exports = {"articleList":"Articlelist_articleList__3QQeA"};